/* PREST | Bruecke solange die AMP Slide Cart App noch installiert ist
 *  20.07.2026
 *
 * Problem: Die App laeuft ueber einen shop-weiten ScriptTag
 * (cdn.jsdelivr.net/gh/apphq/slidecart-dist). Der laesst sich NICHT pro Theme
 * entfernen, nur durch Deinstallation der App. Sie faengt Add-to-Cart-Klicks ab
 * und legt per XMLHttpRequest in den Warenkorb. Da ihre Oberflaeche hier
 * ausgeblendet ist, wuerde sichtbar nichts passieren.
 *
 * Diese Datei stellt das erwartete Verhalten wieder her: nach jedem
 * erfolgreichen Hinzufuegen wird der native Drawer aktualisiert und geoeffnet.
 * Sie beobachtet nur, sie veraendert keine Rueckgabewerte.
 *
 * NACH DEINSTALLATION DER APP: diese Datei loeschen und ihre Zeile aus
 * layout/theme.liquid entfernen.
 */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lock = false;

  function warn(e) { if (window.console && console.warn) console.warn('[prest-amp-bridge]', e); }

  function drawerOffen() {
    var d = document.querySelector('cart-drawer');
    return !!(d && d.classList.contains('active'));
  }

  function removeAmpNodes() {
    try {
      var sel = '.slidecarthq, .slidecarthq-overlay, .upsell-options-overlay';
      Array.prototype.forEach.call(document.querySelectorAll(sel), function (n) {
        if (n && n.parentNode) n.parentNode.removeChild(n);
      });
      document.documentElement.classList.remove('slidecart-open');
      if (document.body) {
        document.body.classList.remove('slidecart-open', 'amp-sc-no-scroll');
        if (document.body.style.overflow === 'hidden' && !drawerOffen()) document.body.style.overflow = '';
      }
    } catch (e) { warn(e); }
  }

  function openNative() {
    try {
      var d = document.querySelector('cart-drawer');
      if (!d) return;
      if (typeof d.open === 'function') { d.open(); return; }
      d.classList.add('animate', 'active');
    } catch (e) { warn(e); }
  }

  function refreshAndOpen() {
    var warOffen = drawerOffen();
    fetch(ROOT + '?section_id=cart-drawer', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.drawer__inner');
        var live = document.querySelector('#CartDrawer .drawer__inner');
        if (fresh && live) live.innerHTML = fresh.innerHTML;
        var d = document.querySelector('cart-drawer');
        if (d) d.classList.remove('is-empty');
      })
      .catch(function (e) { warn(e); })
      .then(function () {
        return fetch(ROOT + '?section_id=cart-icon-bubble')
          .then(function (r) { return r.ok ? r.text() : null; })
          .then(function (html) {
            if (!html) return;
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('.shopify-section') || doc.body.firstElementChild;
            var live = document.querySelector('#cart-icon-bubble');
            if (fresh && live && fresh.innerHTML) live.innerHTML = fresh.innerHTML;
          })
          .catch(function () {});
      })
      .then(function () {
        removeAmpNodes();
        if (!warOffen) openNative();
        lock = false;
      });
  }

  function nachAdd() {
    /* Wird der Drawer gerade schon benutzt (eigener Upsell), nicht dazwischenfunken. */
    if (lock) return;
    lock = true;
    setTimeout(refreshAndOpen, 180);
  }

  /* XMLHttpRequest beobachten (diesen Weg nutzt die App) */
  try {
    var xopen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try { this.__prestUrl = String(url || ''); } catch (e) {}
      return xopen.apply(this, arguments);
    };
    var xsend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
      try {
        var self = this;
        if (/\/cart\/add/.test(self.__prestUrl || '')) {
          self.addEventListener('load', function () {
            try { if (self.status >= 200 && self.status < 300) nachAdd(); } catch (e) { warn(e); }
          });
        }
      } catch (e) { warn(e); }
      return xsend.apply(this, arguments);
    };
  } catch (e) { warn(e); }

  /* fetch ebenfalls beobachten, falls das Theme selbst hinzufuegt.
     Original-Promise wird unveraendert zurueckgegeben. */
  try {
    var nativeFetch = window.fetch;
    if (typeof nativeFetch === 'function') {
      window.fetch = function () {
        var url = '';
        try { url = (arguments[0] && arguments[0].url) || String(arguments[0] || ''); } catch (e) {}
        var p = nativeFetch.apply(this, arguments);
        try {
          if (/\/cart\/add/.test(url) && !drawerOffen()) {
            p.then(function (res) { if (res && res.ok) nachAdd(); }).catch(function () {});
          }
        } catch (e) { warn(e); }
        return p;
      };
    }
  } catch (e) { warn(e); }

  document.addEventListener('DOMContentLoaded', removeAmpNodes);
  window.addEventListener('load', function () { setTimeout(removeAmpNodes, 400); });
})();
